import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#D80027\" d=\"M.414 15.13a12 12 0 0 0 4.282 6.391v-6.39zM10.957 23.955Q11.473 24 12 24c5.545 0 10.21-3.76 11.587-8.87h-12.63zM23.587 8.87C22.21 3.76 17.545 0 12.001 0q-.528.001-1.044.046V8.87zM4.696 2.48A12 12 0 0 0 .414 8.87h4.282z\"></path><path fill=\"#0052B4\" d=\"M23.898 10.434H9.391V.284C8.282.532 7.231.93 6.261 1.46v8.975H.1a12 12 0 0 0 0 3.13h6.16v8.976c.97.53 2.021.928 3.13 1.174v-10.15h14.507a12.1 12.1 0 0 0 0-3.13\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }